declare var location;
export default window.location;